import { render } from "./VendorReportCustom.vue?vue&type=template&id=06ff0fad&scoped=true"
import script from "./VendorReportCustom.vue?vue&type=script&lang=js"
export * from "./VendorReportCustom.vue?vue&type=script&lang=js"

import "./VendorReportCustom.vue?vue&type=style&index=0&id=06ff0fad&scoped=true&lang=css"
import "./VendorReportCustom.vue?vue&type=style&index=1&id=06ff0fad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff0fad"]])

export default __exports__